<script lang="ts">
import { defineComponent, getCurrentInstance, PropType } from "vue";
import { Nullable } from "@/models/nullable.type";
import KlereoSpinner from "@/shared/components/KlereoSpinner.vue";

export default defineComponent({
  components: { KlereoSpinner },
  props: {
    promise: {
      type: Promise as PropType<Nullable<Promise<unknown>>>,
    },
    allowRetry: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
  },
  created() {
    this.executePromise();
  },
  data() {
    return {
      pending: false,
      rejected: false,
      error: null,
      result: null as unknown,
    };
  },
  methods: {
    executePromise() {
      this.pending = true;
      this.rejected = false;
      this.error = null;
      this.result = null;
      this.promise &&
        this.promise
          .then((result) => {
            this.result = result;
          })
          .catch((error) => {
            this.rejected = true;
            this.error = error;
          })
          .finally(() => {
            this.pending = false;
          });
    },
  },
  watch: {
    promise() {
      this.executePromise();
    },
    refresh() {
      this.executePromise();
    },
  },
  emits: ["retry"],
  setup: () => {
    return { hasRetry: !!getCurrentInstance()?.vnode.props?.retry };
  },
});
</script>

<template>
  <div v-if="pending" class="text-center"><KlereoSpinner /></div>
  <div v-else-if="error" class="bg-red-100 border-red-500 p-2 border">
    {{ errorMessage ?? error }}
    <br /><strong
      ><a href="/">{{ $t("BackHomeAction") }}</a></strong
    ><span v-if="allowRetry"> - </span>
    <strong v-if="allowRetry"
      ><a @click="$emit('retry')">{{ $t("RetryAction") }}</a></strong
    >
  </div>
  <template v-else><slot :result="result"></slot></template>
</template>
